import getClientsDetailLink from 'src/common/utils/getClientsDetailLink';

const useClientNameRenderer = ({
  clientData,
  invoice = null,
  isCBOProvider = false,
  hasAccess = true,
  onDrawerOpen,
  additionalProps = {},
}) => {
  const renderClientName = () => {
    let type = 'text';

    // Different logic based on component context
    if (isCBOProvider) {
      // For invoice components - always use button when clientData exists
      if (clientData) {
        type = 'button';
      } else {
        type = 'link';
      }
    } else if (hasAccess !== undefined) {
      // For components with access control (like ClientDetailsCard)
      if (hasAccess && clientData) {
        type = 'button';
      } else {
        type = 'text';
      }
    } else {
      // For other components (like ViewEligibilityAssessment) - always use button
      type = 'button';
    }

    return getClientsDetailLink({
      person: clientData,
      onClick: onDrawerOpen,
      type,
      fallbackName: invoice?.client_name,
      fallbackId: invoice?.client_id,
      ...additionalProps,
    });
  };

  return { renderClientName };
};

export default useClientNameRenderer;
